angular.module('nv.shared.modals').controller('NoteModalCtrl', NoteModalCtrl);

function NoteModalCtrl(
  student,
  studentId,
  activeMode,
  note,
  $mdDialog,
  ErrorModal,
  backgroundJob,
  SpinnerModal,
  Note,
  $scope,
  currentUser,
) {
  this.mode = activeMode;
  this.note = note;
  this.studentName = student ? student.studentDetails.name.lastFirst : null;
  $scope.state = 'OPEN';
  this.studentCount = _.isArray(studentId) ? studentId.length : 1;

  if (this.mode === 'ASSIGN_SINGLE' || this.mode === 'ASSIGN_MANY') {
    this.editIsRestricted = !this.note.canCreate(currentUser);
  } else if (this.mode === 'EDIT_SINGLE') {
    this.editIsRestricted = !this.note.canEdit(currentUser);
  }

  // Todo: implement other attachment options
  this.note.attachments = {
    student: { studentId: student._id, lastFirst: this.studentName },
  };

  // Create single note:
  this.createNote = () => {
    $scope.state = 'IN_PROGRESS';
    this.note
      .$create(createdNote => {
        $scope.state = 'COMPLETE';
        $mdDialog.hide({
          action: 'ADD_NOTE',
          note: createdNote,
        });
      })
      .catch(function(error) {
        ErrorModal.show('Error:', error);
      });
  };

  // Create identical notes for numerous students:
  this.bulkNoteCreate = () => {
    $scope.state = 'IN_PROGRESS';
    Note.bulkCreate(studentId, this.note)
      .then(res => {
        $scope.backgroundJobPromise = backgroundJob(res.headers('nv-background-jobs')).promise();

        $scope.backgroundJobPromise.then(
          () => {
            $scope.state = 'COMPLETE';
            $mdDialog.hide({
              action: 'BULK_ADD_STUDENT_NOTE',
              studentIds: studentId,
            });
          },
          error => handleError(error),
        );
      })
      .catch(errorResponse => {
        handleError(errorResponse);
      });
  };

  function handleError(error) {
    $mdDialog.cancel({ action: 'ERROR', error });
    ErrorModal.show('Error creating student notes', error);
  }

  // Patch individual student note: WARNING, Currently no end-point!
  this.updateNote = () => {
    const isMissingRequiredFields = this.missingRequiredField(this.note);

    if (!isMissingRequiredFields) this._patchNote();
  };

  this._patchNote = () => {
    $scope.state = 'IN_PROGRESS';
    const { FIELDS_THAT_CAN_BE_PATCHED } = Note;

    note
      .$patchFields(FIELDS_THAT_CAN_BE_PATCHED)
      .then(updatedNote => {
        $scope.state = 'COMPLETE';
        $mdDialog.hide({
          action: 'UPDATE_NOTE',
          note: updatedNote,
        });
      })
      .catch(function(error) {
        ErrorModal.show('Error:', error);
      });
  };

  // Validation for otherCatValue:
  this.missingRequiredField = note => {
    const requiredFields: any = _.pick(note, ['body', 'category']);
    const hasRequiredFields = _.every(requiredFields);
    const otherCatSelected = note.category === 'Other';
    if (!hasRequiredFields || (otherCatSelected && !note.categoryOtherVal)) return true;
  };

  // Close modal:
  this.closeModal = () => {
    $mdDialog.hide();
  };

  /**
   * makes sure validation does not fail if `category !== 'Other'`
   */
  this.calculateCategoryVal = () => {
    const { category } = this.note;

    if (category !== 'Other') {
      this.note.categoryOtherVal = null;
    }
  };
}
